import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpandLess from '@material-ui/icons/ExpandLess';

import AdUnitBody from './AdUnitBody';
import AdUnitHead from './AdUnitHead';

import isPresent from '../../../Common/Utils/Present';
import { stopSubmit } from 'redux-form';

type Props = {
  adSizes: string[],
  dispatch: any,
  fields: any,
  handleRemove: any,
  index: number,
  item: string,
  lookupProperties: string[],
  record: any,
  submitFailed: boolean,
  syncErrors: any
};

type StateProps = {
  expand: boolean,
  expandIcon: any
};

class AdUnit extends Component<Props, StateProps> {
  state = { expand: true, expandIcon: <ExpandLess /> };

  componentDidMount() {
    if (
      this.props.record &&
      this.props.record.ad_units &&
      isPresent(this.props.record.ad_units[this.props.index])
    ) {
      this.setState({ expand: false, expandIcon: <ExpandMore /> });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.submitFailed !== prevProps.submitFailed) {
      if (
        this.props.syncErrors &&
        this.props.syncErrors.ad_units &&
        this.props.syncErrors.ad_units[this.props.index]
      ) {
        this.scrollToElement(this.props.index);
        this.props.dispatch(stopSubmit('record-form'));
      } else {
        window.scrollTo(0, 0);
        this.props.dispatch(stopSubmit('record-form'));
      }
    }
  }

  handleTouchTap = (index) => {
    if (this.state.expand) {
      this.setState({ expand: false, expandIcon: <ExpandMore /> });
    } else {
      this.setState({ expand: true, expandIcon: <ExpandLess /> });
    }
  };

  scrollToElement = (index) => {
    ReactDOM.findDOMNode(this).scrollIntoView();
    if (this.state.expand === false) {
      this.handleTouchTap(this.props.index)
    }
  };

  render() {
    return (
      <div style={{ border: '2px solid #f5f5f5' }}>
        <AdUnitHead
          expandIcon={this.state.expandIcon}
          fields={this.props.fields}
          handleRemove={this.props.handleRemove}
          handleTouchTap={this.handleTouchTap}
          index={this.props.index}
          record={this.props.record} />
        <AdUnitBody
          adSizes={this.props.adSizes}
          expand={this.state.expand}
          index={this.props.index}
          item={this.props.item}
          lookupProperties={this.props.lookupProperties}
          record={this.props.record} />
      </div>
    )
  }
};

export default AdUnit;



// WEBPACK FOOTER //
// ./src/views/Components/Placements/Partials/AdUnit.tsx